var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.data
    ? _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-checkbox", {
            attrs: { label: _vm.label, value: _vm.value },
            on: {
              input: function ($event) {
                return _vm.onValue($event)
              },
            },
          }),
          _vm._v(" " + _vm._s(_vm.data) + " "),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }